
<div style="border: 5px solid #f9c916;" class="confirm-width">
  <mat-toolbar style="background-color: #f9c916; height: 35px;">
      <div style="width: 100%; display: inline-flex; justify-content: space-between;">
          <h2 style="color: black; font-weight: 400;">Application Alert</h2>

          <img style="float: right;cursor: pointer;" (click)="closeMaintenanceBanner()" src="../../../../../../assets/images/close.svg" alt="close">
      </div>
  </mat-toolbar>
  <mat-dialog-content>
      <div class="md-dialog-content user-role-dialog-content" style="padding-top: 12px; padding-left: 18px;" *ngIf="appMaintenanceObj.maintenanceMsg">

          <span style="color: black; font-size: 14px;">{{appMaintenanceObj.maintenanceMsg}}</span>
      </div>
  </mat-dialog-content>


  <mat-dialog-actions align="end" style="margin-bottom: -4px;  padding-right: 10px;">
      <button class="sec-button-21" style="margin-left:20px;" *ngIf="isReleaseNoteAvailable" (click)="showReleaseNotes()">RELEASE NOTES</button>
      <button class="prim-button-2" style="margin-left:190px;" (click)="dismissMaintenanceBanner()">DISMISS</button>
      <button class="sec-button-2" style="margin-left:10px;" (click)="closeMaintenanceBanner()">CLOSE</button>
  </mat-dialog-actions>


<mat-dialog-content>
  <div class="md-dialog-content user-role-dialog-content" style="padding-top: 12px; padding-left: 18px;padding-bottom: 15px;overflow-y: scroll;
  height: 80px;
  border-top: solid 1px;font-size: 14px;" *ngIf="releaseNoteFlag">{{appMaintenanceObj.releaseNote}}
  </div>
</mat-dialog-content>
</div>
